import React, { lazy, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Context } from "../../utils/Context";

//material UI
import { Grid } from "@mui/material";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";

//images
import QuizFund from "../../images/fund-image.svg";
import Truebutton from "../../images/an-true-button.svg";
import Falsebutton from "../../images/false-button.svg";

//componentes
const GenderHeader = lazy(() => import("../../components/Header"));

export default function GenderResponseScreen() {
  const navigate = useNavigate();
  const { rules, setRules } = useContext(Context);

  const handleClick = (e) => {
    console.log(rules + " <-----");
    if (rules === 0) setRules(1);
    console.log(rules + " <-----");

    navigate("/question");
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        minHeight: "100vh",
      }}
    >
      <Grid item xs></Grid>
      <Grid
        item
        xs={10}
        sx={{
          marginBottom: {
            xs: "20%",
            sm: "5%",
            md: "5%",
            lg: "0",
            xl: "0",
          },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <GenderHeader></GenderHeader>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              margin: "1vh 5vw",
              padding: "1rem",
              borderRadius: "1rem",
              background: "rgba(38, 50, 56, 0.3)",
              height: {
                xs: "40vh",
                sm: "50vh",
                md: "45vh",
                lg: "50vh",
                xl: "50vh",
              },
            }}
          >
            <img
              src={QuizFund}
              width={"auto"}
              height={"100%"}
              alt="Imagem exemplificativa de acordo com a questão"
            ></img>
          </Grid>
          <Grid item xs={12} textAlign={"center"} marginTop={"2vh"}>
            <img
              src={Truebutton}
              alt="botão de verdadeiro"
              sx={{ zIndex: "-1" }}
              style={{ animation: "bounce 0.9s 2", animationDelay: "2s" }}
            />
          </Grid>
          <Grid item xs={12} textAlign={"center"}>
            <img
              src={Falsebutton}
              alt="botão de false"
              sx={{ zIndex: "-1" }}
              style={{
                animation: "shake 0.3s 2",
                animationDelay: "4s",
              }}
            />
          </Grid>
          <Grid item xs={12} textAlign={"center"}>
            <ArrowForwardOutlinedIcon
              sx={{
                width: {
                  xs: "10vw",
                  sm: "10vw",
                  md: "7vw",
                  lg: "4vw",
                  xl: "4vw",
                },
                height: "auto",
                animation: "shake 3s infinite",
              }}
              onClick={handleClick}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs></Grid>
    </Grid>
  );
}
